/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Expires_ColInputs */

const en_admin_invite_codes_expires_col = /** @type {(inputs: Admin_Invite_Codes_Expires_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expires`)
};

/**
* | output |
* | --- |
* | "Expires" |
*
* @param {Admin_Invite_Codes_Expires_ColInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_expires_col = /** @type {((inputs?: Admin_Invite_Codes_Expires_ColInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Expires_ColInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_invite_codes_expires_col(inputs)
});
export { admin_invite_codes_expires_col as "admin.invite_codes.expires_col" }